@if(!visibleTree && treeLength!=0){
  <button mat-button (click)="showTreeData()" style="color:var(--warmOrange);"> {{'tridys.show_data' | translate}}
    <mat-icon>visibility</mat-icon>
  </button>
}

@if( treeLength==0){
  <span class="p-1 ms-4"><strong> </strong></span><br>
}

@if(visibleTree){
  <button mat-button (click)="hideTreeData()" style="color:var(--warmOrange);"> {{'tridys.hide_data' | translate}}
    <mat-icon>visibility_off</mat-icon>
  </button>

  <mat-tree [dataSource]="getDataSource" [treeControl]="treeControl" class="example-tree w-100 m-auto " style="background-color: white;">
    <mat-tree-node *matTreeNodeDef="let node;let index=index" matTreeNodeToggle class="border-bottom" (click)="onLeafNodeClick(node)">
  
      <span class="p-1 ms-2"><strong>{{node.name}}</strong></span><br>
      <span class="p-1 ms-2 text-break text-muted" style=" overflow: hidden; white-space: nowrap; text-overflow: ellipsis;" >{{node.value}}</span>
    </mat-tree-node>
    <mat-nested-tree-node *matTreeNodeDef="let node;let index=index; when: hasChild" >
        <div class="mat-tree-node border-bottom ">
            <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                <mat-icon class="mat-icon-rtl-mirror">
                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
            </button>
  
            <span class="p-1 ms-2"><strong>{{node.name}}</strong></span><br>
          </div>
  
        <div [class.example-tree-invisible]="!treeControl.isExpanded(node)" role="group">
            <ng-container matTreeNodeOutlet></ng-container>
        </div>
    </mat-nested-tree-node>
    <mat-nested-tree-node *matTreeNodeDef="let node;let index=index; when: isArrayType" >
        <div class="mat-tree-node border-bottom">
          <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
              <mat-icon class="mat-icon-rtl-mirror">
              {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
              </mat-icon>
          </button>
  
          <span><strong>{{node.name}}</strong></span><br>
          <span class="p-1 text-break text-muted" style=" overflow: hidden; white-space: nowrap; text-overflow: ellipsis;" >{{node.value}}</span>
        </div>
        <div [class.example-tree-invisible]="!treeControl.isExpanded(node)" role="group">
            <ng-container matTreeNodeOutlet>
                <div class="mat-tree-node border-bottom">
                  <span class="p-1" style="color:black;" >List-Items</span>
                </div>
            </ng-container>
        </div>
    </mat-nested-tree-node>
  </mat-tree>   
}
